export const integrations = {
  name: 'integrations',
  title: 'integrations.menu.title',
  icon: () => import('@shared/components/icon/sidebar/icon-widgets.vue'),
  route: { name: 'integrations.dashboard' }
};
